// Generic imports
import styled from "styled-components"

// Static imports

export const Styles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1003;
  width: 100vw;
  height: 100vh;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;

  .success-modal {
    background: white;
    box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    padding: 20px;
    max-width: 500px;
    text-align: center;
  }

  .success-modal-img {
    width: 55%;
    margin: auto;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  button {
    padding-left: 50px;
    padding-right: 50px;
    margin-top: 20px;
    margin-bottom: 15px;
  }
`
